import React, { useState, useRef } from 'react';

export type FloatingInputProps = {
  label: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  name?: string;
  placeholder?: string;
  className?: string;
  inputClassName?: string;
  disabled?: boolean;
};

const EyeIcon = () => (
  <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"/><circle cx="12" cy="12" r="3"/></svg>
);
const EyeOffIcon = () => (
  <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-7 0-11-7-11-7a21.81 21.81 0 0 1 5.06-6.06M1 1l22 22"/><path d="M9.53 9.53A3 3 0 0 0 12 15a3 3 0 0 0 2.47-5.47"/></svg>
);
const CalendarIcon = () => (
  <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <rect x="3" y="4" width="18" height="16" rx="4" stroke="currentColor" strokeWidth="2" fill="white"/>
    <path d="M8 2v4M16 2v4M3 10h18" stroke="currentColor" strokeWidth="2"/>
    <rect x="7" y="14" width="2" height="2" fill="currentColor"/>
    <rect x="11" y="14" width="2" height="2" fill="currentColor"/>
    <rect x="15" y="14" width="2" height="2" fill="currentColor"/>
  </svg>
);

const FloatingInput: React.FC<FloatingInputProps> = ({
  label,
  value,
  onChange,
  type = 'text',
  name,
  placeholder,
  className = '',
  inputClassName = '',
  disabled = false,
}) => {
  const [show, setShow] = useState(false);
  const isPassword = type === 'password';
  const isDate = type === 'date';
  const inputType = isPassword ? (show ? 'text' : 'password') : type;
  const inputRef = useRef<HTMLInputElement>(null);

  const handleCalendarClick = () => {
    if (inputRef.current) {
      inputRef.current.showPicker ? inputRef.current.showPicker() : inputRef.current.focus();
    }
  };

  return (
    <div className={`w-full p-2 bg-white rounded-lg border border-gray-200 ${className}`}>
      <label className="block text-sm text-gray-500 mb-0" htmlFor={name}>{label}</label>
      <div className="relative">
        <input
          ref={inputRef}
          id={name}
          name={name}
          type={inputType}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          className={`block w-full text-lg text-gray-800 bg-transparent border-0 p-0 focus:ring-0 focus:border-transparent ${isDate ? '[&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-inner-spin-button]:hidden [&::-webkit-outer-spin-button]:hidden' : ''} ${inputClassName}`}
        />
        {/* Affiche l'icône œil uniquement si c'est un champ password et PAS un champ date */}
        {isPassword && !isDate && (
          <button
            type="button"
            tabIndex={-1}
            onClick={() => setShow(!show)}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-blue-500 focus:outline-none"
          >
            {show ? <EyeOffIcon /> : <EyeIcon />}
          </button>
        )}
        {/* Affiche l'icône calendrier uniquement si c'est un champ date */}
        {isDate && (
          <button
            type="button"
            tabIndex={-1}
            onClick={handleCalendarClick}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-blue-500 focus:outline-none"
          >
            <CalendarIcon />
          </button>
        )}
      </div>
    </div>
  );
};

export default FloatingInput; 